import qc from 'qc'
import { createImageComponent } from '@ps/bridge/qc/bin/image'

/**
 * 更新图片节点的资源时的特殊逻辑
 */
export const createImageComponentBeforeUpdateImage = async ({
  file,
  node,
  resourcePath,
}: {
  file: File
  node: qc.Node
  resourcePath: string
}) => {
  const params: {
    file: File
    name: string
    resourcePath: string
  } = {
    file,
    name: file.name,
    resourcePath,
  }
  return await createImageComponent(params)
}
